import { render, staticRenderFns } from "./crudPHPInterfaces.vue?vue&type=template&id=eb1916ba"
import script from "./crudPHPInterfaces.vue?vue&type=script&lang=js"
export * from "./crudPHPInterfaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports